import { getEnvVar } from '../util/getEnvVar';

const getEnv = () => {
  const { host = '' } = window.location;

  if (host.includes('.local.')) {
    return 'api.dev-integration-useast1.clinicalresearch.io';
  } if (host.includes('.qa.') || host.includes('-qa-')) {
    return 'api.np.clinicalresearch.io';
  }

  return 'api.clinicalresearch.io'; // Prod
};

/**
 * Get the current region
 * @return   {string | null} containing the current region
 */
const getRegion = (): string | null => {
  const hostnameFiltered = window.location.host
    .replace('http://', '')
    .replace('https://', '')
    .replace('subjects.', '')
    .replace('esource.', '');

  const prefix = hostnameFiltered.substring(0, hostnameFiltered.indexOf('.'));
  return (prefix === 'clinicalresearch') ? 'us' : prefix;
};

/**
 * Get the domain, allowing the region to be overridden but otherwise pulling it from the URL
 * @param overrideRegion  {string | null} containing the region to potentially override with
 * @return                string containing the current domain
 */
const getDomain = (overrideRegion: (string | null) = null) => {
  const region = overrideRegion || getRegion();

  // If an API URL env variable is given, use that
  const apiEndpointEnvVar = getEnvVar('REACT_APP_PUBLIC_API_ENDPOINT');
  if (apiEndpointEnvVar!!) {
    return apiEndpointEnvVar;
  }

  // ... Otherwise, compute from the request parameters
  if (!region) {
    throw new Error('Region is missing from url.');
  }

  let prefix = '';
  if (!['us', 'local', 'qa'].includes(region.toLowerCase())) {
    prefix = `${region}.`;
  }

  return `https://${prefix}${getEnv()}/esource/v1`;
};

export default getDomain;
export { getRegion, getDomain };
